<div class="table-responsive">
  <table [class]="tableClass">
    <thead>
      <tr [class]="headerRowClass">
        @for (col of visibleColumns; track col.id) {
        <th [attr.scope]="'col'" [class]="thScopeClass(col)">
          @if (col.sortable) {
          <button
            type="button"
            class="inline-flex max-w-full items-center gap-1 rounded font-normal text-inherit hover:text-primary hover:underline"
            (click)="onSort(col)"
          >
            {{ col.header }}
            @if (sortIndicator(col); as dir) {
            <span class="text-primary">{{ dir === 'asc' ? '↑' : '↓' }}</span>
            }
          </button>
          } @else {
          {{ col.header }}
          }
        </th>
        }
      </tr>
    </thead>
    <tbody>
      <app-list-module-table-states
        [loading]="loading"
        [hasRows]="rows.length > 0"
        [colspan]="colspan"
        [emptyMessage]="emptyMessage"
      />
      @for (row of rows; track trackRow($index, row); let i = $index) {
      <tr
        [class]="
          variant === 'compact'
            ? 'border-b border-gray-100 dark:border-[#191e3a] last:border-0 hover:bg-gray-50 dark:hover:bg-white/5 transition-colors'
            : 'border-none'
        "
      >
        @for (col of visibleColumns; track col.id) {
        <td [class]="tdClass(col)">
          @if (cellTemplate(col.id); as tpl) {
          <ng-container
            [ngTemplateOutlet]="tpl"
            [ngTemplateOutletContext]="rowContext(row, i)"
          />
          }
        </td>
        }
      </tr>
      }
    </tbody>
  </table>
</div>
